
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 250 250"}},[_c('path',{staticClass:"stroke",attrs:{"d":"M46 65h157.3v119.9H46z"}}),_c('path',{staticClass:"stroke",attrs:{"d":"M46 65l78.2 78.7L203.3 65m0 119.9l-62.9-57.4M46 184.9l61.8-57.6"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      